import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import classNames from 'classnames';
import { LinkVariant, ReadMoreVariant, RenderType } from '../../enums';
import { Link } from '../Link';
import { useReadMoreVisibility } from './hooks';
import styles from './ReadMore.module.scss';
const ReadMore = ({ autoScrollToContent = true, children, collapseText, defaultExpanded = false, expandText, onClick, rows = 1, variant = ReadMoreVariant.Default, ...restProps }) => {
    const contentRef = useRef(null);
    const linkRef = useRef(null);
    const { isVisible, toggleVisibility } = useReadMoreVisibility({
        contentRef,
        linkRef,
        isOpen: defaultExpanded,
        rows,
        autoScrollToContent,
    });
    const toggleReadMore = () => {
        toggleVisibility();
        onClick?.(isVisible);
    };
    return (_jsxs("div", { ...restProps, children: [_jsx("section", { ref: contentRef, className: classNames([
                    'position-relative pr-1x pb-0-5x overflow-hidden',
                    styles.truncate,
                    styles[variant],
                ], {
                    [styles.fadeAtTheEnd]: !isVisible,
                }), 
                // @ts-expect-error -- New HTML feature
                hidden: isVisible ? false : 'until-found', "data-rows": rows, "aria-hidden": "false", 
                // @ts-expect-error -- use css variable
                style: !defaultExpanded ? { '--line-number': rows, height: 'auto' } : {}, children: children }), _jsx(Link, { variant: LinkVariant.Brand, onClick: toggleReadMore, ref: linkRef, className: "mt-0-5x", ariaHidden: true, as: RenderType.Button, tabIndex: -1, children: isVisible ? collapseText : expandText })] }));
};
export { ReadMore };
